import React from 'react';
import './AboutEnergyTracker.scss';

const AboutEnergyTracker = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-content">
          <h2 className="section-title">About the Energy Tracker</h2>
          <p className="about-description">
            Africa Energy Tracker is a comprehensive digital platform designed to track, visualize, and analyze investments and impacts in energy access and clean energy financing across Africa. Our goal is to provide transparent, accessible data that helps researchers, policymakers, donors, and civil society organizations understand how energy investments are shaping Africa's future.
          </p>
          <a href="/about" className="btn btn-secondary about-cta">
            Learn More About Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutEnergyTracker;



